/**
 * OIDC client config for the tacosai-admin client.
 *
 * Issuer is the tacosai-api-node beta or prod endpoint. Set via
 * VITE_OIDC_ISSUER at build time; the default targets beta so a
 * vanilla `pnpm dev` Just Works against the running infra.
 *
 * The tacosai-admin client is registered in
 * tacosai-api-node/src/auth/clients.ts with redirect_uris:
 *   - https://admin.tacosai.com/auth/callback           (prod, future)
 *   - https://beta-admin-v5.tacosai.com/auth/callback   (custom domain, future)
 *   - https://tacosai-admin-beta.pages.dev/auth/callback (current beta deploy)
 *   - http://localhost:5174/auth/callback               (local dev)
 *
 * Scopes are the union of OIDC core + admin: scopes from docs/26-oidc-design.md.
 */

const OIDC_ISSUER = import.meta.env['VITE_OIDC_ISSUER'] ?? 'https://tacosai-api-beta.fly.dev';

export const OIDC_CONFIG = {
  issuer: OIDC_ISSUER,
  client_id: 'tacosai-admin',
  authorization_endpoint: `${OIDC_ISSUER}/oidc/auth`,
  token_endpoint: `${OIDC_ISSUER}/oidc/token`,
  userinfo_endpoint: `${OIDC_ISSUER}/oidc/userinfo`,
  end_session_endpoint: `${OIDC_ISSUER}/oidc/end_session`,
  scopes: [
    'openid',
    'profile',
    'email',
    'admin:users',
    'admin:payments',
    'admin:gpu',
    'admin:workflows',
    'admin:audit',
    'admin:config',
    'admin:moderation',
  ].join(' '),
} as const;

/** Build the callback URI from the current origin. Must exactly match a registered redirect_uri. */
export function getRedirectUri(): string {
  return `${window.location.origin}/auth/callback`;
}
